import React from "react";
import { ThreeCircles } from "react-loader-spinner";

export default function Spinner() {
  return (
    <ThreeCircles
      height="25"
      width="25"
      color="#4fa94d"
      wrapperStyle={{}}
      wrapperClass=""
      visible={true}
      ariaLabel="three-circles-rotating"
      outerCircleColor="#fe8366"
      innerCircleColor="#fe8366"
      middleCircleColor="#010f2e"
    />
  );
}
